import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Spinner } from '@components/loading-spinner';

import { useInvalidateAuthentication } from 'api/authentication/hooks';
import { useSignupCompanyConfirmUuid } from 'api/users/hooks';

export const AutoConfirmPage = () => {
  const [searchParams] = useSearchParams();
  const { invalidateCurrentUser } = useInvalidateAuthentication();
  const signupConfirmUuidMutation = useSignupCompanyConfirmUuid({
    onSuccess: invalidateCurrentUser,
  });

  useEffect(() => {
    const confirmationUuid = searchParams.get('uuid');
    if (confirmationUuid) {
      signupConfirmUuidMutation.mutate(confirmationUuid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: Error handling... design yes?

  return <Spinner />;
};
